import { LINKS } from '@/constants/LINKS';
import { TFunction } from 'i18next';

import phoneIcon from '@/assets/icons/lead-form/material-symbols_call-outline.svg';
import whatsappIcon from '@/assets/icons/lead-form/ic_baseline-whatsapp.svg';
import telegramIcon from '@/assets/icons/lead-form/ri_telegram-2-line.svg';
import viberIcon from '@/assets/icons/lead-form/basil_viber-outline.svg';
import signalIcon from '@/assets/icons/lead-form/hugeicons_signal.svg';

export const getContactOptions = (t: TFunction) => [
  {
    value: 'phone',
    label: t('contacts.phone'),
    icon: phoneIcon,
    link: LINKS.phone,
  },
  {
    value: 'whatsapp',
    label: 'WhatsApp',
    icon: whatsappIcon,
    link: LINKS.whatsapp,
  },
  {
    value: 'telegram',
    label: 'Telegram',
    icon: telegramIcon,
    link: LINKS.telegram,
  },
  {
    value: 'viber',
    label: 'Viber',
    icon: viberIcon,
    link: LINKS.viber,
  },
  {
    value: 'signal',
    label: 'Signal',
    icon: signalIcon,
    link: LINKS.signal,
  },
];
